import { BaseThunkExtra } from '@meprism/shared'
import { configuredHub, configuredApi } from '../app/aws-exports'
import { Toast } from '../components/toast/toast'
import AnalyticsManager from '../services/AnalyticsManager'

export type PortalAppThunkExtraType = BaseThunkExtra

export const portalAppThunkExtra: PortalAppThunkExtraType = {
  API: configuredApi,
  Hub: configuredHub,
  AnalyticsManager: AnalyticsManager,
  Toast: Toast,
  // @TODO: This
  handleSupport: () => {},

}
